import React, { useState } from 'react';
import { supabase } from '../../../lib/supabaseClient';
import { useTranslation } from 'react-i18next';

export function MagicLinkForm({ setView, setError, setMessage, setLoading }) {
  const [email,setEmail] = useState('');
  const [cooldown,setCooldown] = useState(0);
  const { t, i18n } = useTranslation();

  React.useEffect(()=>{ if(!cooldown) return; const id=setInterval(()=>setCooldown(c=>c?c-1:0),1000); return ()=>clearInterval(id); },[cooldown]);

  const onSubmit = async (e)=>{
    e.preventDefault(); setError(''); setMessage(''); setLoading(true);
    console.log('[MagicLinkForm] ✨ Magic link attempt:', { email });
    
    try {
      console.log('[MagicLinkForm] 📡 Calling supabase.auth.signInWithOtp...');
      const { error } = await supabase.auth.signInWithOtp({ email, options:{ shouldCreateUser:true, emailRedirectTo: (process.env.REACT_APP_SITE_URL || window.location.origin) + `/?lang=${encodeURIComponent(i18n.language||'en')}` } });
      if(error) throw error;
      
      console.log('[MagicLinkForm] ✅ Magic link sent successfully');
      setMessage(t('auth.magic_sent','We sent you a magic link to your email'));
      setCooldown(60);
    } catch(err){ 
      console.error('[MagicLinkForm] ❌ Magic link FAILED:', {
        message: err.message,
        code: err.code,
        status: err.status
      });
      setError(err.message || t('auth.errors.magic_failed','Could not send link')); 
    } finally { 
      setLoading(false); 
      console.log('[MagicLinkForm] 🏁 Magic link attempt complete');
    }
  };

  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div>
        <label className="block text-sm text-gray-300 mb-1">{t('auth.email','Email')}</label>
  <input autoFocus type="email" value={email} onChange={e=>setEmail(e.target.value)} required className="input-primary w-full" />
      </div>
      <div className="flex gap-3 justify-end pt-2">
        <button type="button" onClick={()=>setView('login')} className="btn-secondary">{t('common.cancel','Cancel')}</button>
        <button disabled={cooldown>0} type="submit" className="btn-primary">{cooldown? t('auth.magic.resend_in',`Reenviar (${cooldown})`).replace('{{s}}', String(cooldown)) : t('auth.magic.send','Send link')}</button>
      </div>
    </form>
  );
}
